import { env } from 'next-runtime-env';

export const ECOM_API_ENDPOINT = env('NEXT_PUBLIC_ECOM_API_ENDPOINT');

export const GraphQLEndpoint = `${ECOM_API_ENDPOINT}/graphql`;
